<template>
    <div>
        <div class="text-center" v-if="compact">
            <div>
                <a href="#" @click.prevent="$emit('openCohort')">
                    <small class="font-weight-bold">
                        <i class="fas fa-users mr-1"></i> {{ registration.cohort.name }}
                    </small>
                </a>
            </div>
            <div class="mt-2" v-if="groups && groups.length">
                <a href="#" @click.prevent="$emit('openGroup')">
                    <small class="font-weight-bold">
                        <i class="fas fa-user-friends mr-1"></i> {{ groups[0].name }}
                    </small>
                </a>
            </div>
        </div>
        
        <div class="text-center pt-3" v-if="!compact">
            <a href="#" @click.prevent="$emit('openCohort')">
                <small class="font-weight-bold">
                    <i class="fas fa-users mr-1"></i> {{ registration.cohort.name }}
                </small>
            </a>
            <a href="#" @click.prevent="$emit('openGroup')" v-if="groups && groups.length" class="ml-3">
                <small class="font-weight-bold">
                    <i class="fas fa-user-friends mr-1"></i> {{ groups[0].name }}
                </small>
            </a>
        </div>
    </div>
</template>

<script>
    export default {

        props: {

            registration: {
                type: Object,
                required: true
            },
            
            groups: {
                type: Array,
                default: null
            },

            compact: {
                type: Boolean,
                default: false
            },
        },
    }
</script>
